export const APP_TOUR = {
    WELCOME_MESSAGE: {
        key: 'WELCOME_MESSAGE',
        value: 'Welcome {{displayName}}!!'
    },
    WELCOME_MESSAGE_DESCRIPTION: {
        key: 'WELCOME_MESSAGE_DESCRIPTION',
        value: 'We are glad you are here.'
    },
    WELCOME_MESSAGE_INTRODUCTION: {
        key: 'WELCOME_MESSAGE_INTRODUCTION',
        value: "I'm your success manager from Perfect Doc Studio. Let me invite you to our guided tour to create your first document template."
    },
    SKIP_TOUR_BUTTON: {
        key: 'SKIP_TOUR_BUTTON',
        value: 'Skip this tour'
    },
    TAKE_TOUR_BUTTON: {
        key: 'TAKE_TOUR_BUTTON',
        value: 'Take this tour'
    },
    CHECKOUT_DEMO_VIDEO_MESSAGE: {
        key: 'CHECKOUT_DEMO_VIDEO_MESSAGE',
        value: 'Alternatively, you can check out our demo to get started.'
    },
    TOOLTIP_TITLE_START_DESIGNING: {
        key: 'TOOLTIP_TITLE_START_DESIGNING',
        value: 'Click here to start'
    },
    TOOLTIP_TITLE_TEMPLATE_NAME: {
        key: 'TOOLTIP_TITLE_TEMPLATE_NAME',
        value: 'Enter a unique name for your template'
    },
    TOOLTIP_TITLE_CATEGORY: {
        key: 'TOOLTIP_TITLE_CATEGORY',
        value: 'Add a new category or select from the list'
    },
    TOOLTIP_TITLE_TEAM: {
        key: 'TOOLTIP_TITLE_TEAM',
        value: 'Select a team from the list'
    },
    TOOLTIP_TITLE_MASTER_TEMPLATES: {
        key: 'TOOLTIP_TITLE_MASTER_TEMPLATES',
        value: 'Click to get started with out of box templates'
    },
    TOOLTIP_TITLE_MASTER_TEMPLATES_SELECTION: {
        key: 'TOOLTIP_TITLE_MASTER_TEMPLATES_SELECTION',
        value: 'Search & select a template of your choice'
    },
    TOOLTIP_TITLE_CREATE_TEMPLATE_BUTTON: {
        key: 'TOOLTIP_TITLE_CREATE_TEMPLATE_BUTTON',
        value: 'Click to create the template'
    },
    TOOLTIP_TITLE_TEMPLATE_CREATED: {
        key: 'TOOLTIP_TITLE_TEMPLATE_CREATED',
        value: 'Awesome!! You have succesfully created your first template'
    },
    SKIP_BUTTON: {
        key: 'SKIP_BUTTON',
        value: 'Skip'
    },
    BACK_BUTTON: {
        key: 'BACK_BUTTON',
        value: 'Back'
    },
    NEXT_BUTTON: {
        key: 'NEXT_BUTTON',
        value: 'Next'
    },
}